import { render, staticRenderFns } from "./IconPasswd.vue?vue&type=template&id=61b8ed04"
import script from "./IconPasswd.vue?vue&type=script&lang=js"
export * from "./IconPasswd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports